exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-wrapper[data-v-4887ce98]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;grid-gap:15px;gap:15px}@media (min-width:769px){.flex-wrapper[data-v-4887ce98]{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}}@media (max-width:768px){.flex-wrapper[data-v-4887ce98]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}}", ""]);

// exports
